<template>
    <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <form @submit.prevent="validateAdvancePayment" class="form">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('crm.advances.validate') }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                          <span class="svg-icon svg-icon-1">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                                    fill="currentColor" />
                              <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                                    fill="currentColor" />
                              </svg>
                          </span>
              </div>
            </div>
            <div class="modal-body">
              <RequiredText />

              <InputDate2
                  id="won-date"
                  containerClass="col-12 col-md-12 mt-2 mb-2"
                  name="payments-date_end"
                  :label="$t('date')"
                  labelClass="form-label"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="false" size="lg"
                  v-model="formValidateData.payment_date"
                  placeholder="JJ-MM-AAAA"
              />
              <div class="row">
                <div class="col-12 col-md-12 mb-5">
                  <label class=" font-weight-600 mb-3"> {{ $t('invoices.label.file') }} <span class="ms-2 text-danger">*</span></label>
                  <UploadFile id="validate_file_upload" size="2" v-model="formValidateData.files"/>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <cash-deposit v-model="formValidateData" :source-currency="invoiceCurrency" :id="id"></cash-deposit>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
              <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoadingValidate"></Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  
  </template>
  
  <script setup>
  
    import { ref, defineProps } from "vue";
    import {useStore} from "vuex";
    import InputDate2 from "@/components/InputDate2.vue"
    import Button from "@/components/Button.vue"
    import i18n from "@/plugins/i18n";
    import {useRoute} from "vue-router";
    import RequiredText from "@/components/RequiredText.vue"
    import UploadFile from "@/components/UploadFile";
    import CashDeposit from "@/Modules/CRM/views/Payment/components/CashDeposit.vue";

    const store = useStore()
    const route = useRoute()
  
    const emits = defineEmits(['load'])
  
    const props = defineProps({
      id: {
        type: String,
        required: true
      },
      invoiceCurrency: {
        type: Object,
        required: true
      },
    })
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
  
    const formattedDate = `${day}-${month}-${year}`;
    const formValidateData = ref({
      advance_invoice_id: route.params.id,
      payment_date: formattedDate,
      files : [],
      exchange_rate: '',
      account_id: '',
      box_id: '',
      payment_account_type: 'account'
    })
    const isLoadingValidate = ref(false)
  
    function validateAdvancePayment(){
      isLoadingValidate.value = true
     
      store.dispatch('advances/validateAdvancePayment', formValidateData.value)
          .then(res => {
            emits('load')
            closeModal()
            isLoadingValidate.value = false
            window.toastr['success'](i18n.global.t("notification.payment_validated"))
          })
          .catch((err) => {
            isLoadingValidate.value = false
          })
    }
  
    function closeModal(){
      $('#'+props.id).modal('toggle')
    }
  
  </script>
  
  <style scoped></style>
  